import { ListOrgSecretsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { orgSecretKeys } from "../queryKeys";

const listOrgSecrets = async () => {
  const resp = await api.get<ListOrgSecretsResponseBodyType>("/v2/org-secrets");
  return resp.data;
};

export const useOrgSecrets = () => {
  return useQuery<ListOrgSecretsResponseBodyType, Error>({
    queryKey: orgSecretKeys.all,
    queryFn: async () => listOrgSecrets(),
  });
};
